<template>
  <router-view />
</template>
<script>
  export default {
    name: 'ExtratoFornecedorModule',
  }
</script>
